import { DoSetOnBeforeUnload } from "./DoSetOnBeforeUnload";

export function SetOnBeforeUnload() {
  setTimeout(DoSetOnBeforeUnload, 500);
}
